import { createContext, useContext, useState } from 'react';
import fr from './fr';
const I18nContext = createContext({ t: fr, lang: 'fr', setLang: () => {} });
export function I18nProvider({ children }) {
  const [lang, setLang] = useState('fr');
  const t = lang === 'fr' ? fr : fr;
  return <I18nContext.Provider value={{ t, lang, setLang }}>{children}</I18nContext.Provider>;
}
export function useI18n() { return useContext(I18nContext); }
